import {React,useState} from 'react';
import { useLocation } from 'react-router-dom';
import { Link, useNavigate} from 'react-router-dom';
import BookingConfirmation from './booking-confimation.component'
import { toast } from 'react-toastify';
import DataService from '../../services/data.service';
import LoaderOverlay from '../common/loader.component';

const BookingDetails = () => {
  const location = useLocation();
  const booking = location.state?.booking;
 const [modalShow, setModalShow] = useState(false);
   const [loading, setLoading] = useState(false);
 
 const [status,setStatus] = useState('')
 console.log(booking)
  if (!booking) return <div className="alert alert-warning mt-4">No booking selected.</div>;
const navigate = useNavigate();

  const getStatusBadgeClass = (status) => {
    switch (status) {
      case 'cancelled':
        return 'bg-danger';
      case 'open':
        return 'bg-warning text-dark';
      default:
        return 'bg-success';
    }
  };

  const handleApprove = () => {
    setStatus('confirmed')
      setModalShow(true);
    console.log("Approve clicked", booking.booking_id);
    // Call API to approve booking here
  };

  const handleReject = () => {
      setModalShow(true);
    setStatus('cancelled')
  };
    const handleCompleted = () => {
      setModalShow(true);
    setStatus('completed')
  };
  const updateStatus = (reason) => {
    let data = {
      token:booking.token,
      status:status,
      reason:reason,// reason from booking confirmation component
      role:'owners'

    }
    setLoading(true);
    DataService.updateBookingStatus(data)
      .then((response) => {
      toast.success('Status updated successfully and email sent successfully.')
      navigate('/bookings')
        setModalShow(false);
      })
      .catch(() => {
        setLoading(false);
        setModalShow(false);
      });
  };
  return (
    <>
     <LoaderOverlay loading={loading} />

      <div className="card shadow">
        <div className="card-header bg-primary text-white">
          <h5 className="mb-0">Booking Details</h5>
        </div>
        <div className="card-body">
       
            <div className="mb-4 d-flex gap-3" style={{float:'right'}}>
             <>
  {(booking.status === 'open' || booking.status === 'cancelled') && (
    <button className="btn btn-success" onClick={handleApprove}>
      Approve
    </button>
  )}
</>

<>
  {(booking.status === 'open' || booking.status === 'confirmed') && (
    <button className="btn btn-danger" onClick={handleReject}>
      Reject
    </button>
  )}
</>
<>
  {(booking.status === 'confirmed') && (
    <button className="btn btn-success" onClick={handleCompleted}>
      Completed
    </button>
  )}
</>
            </div>
         

          <div className="row mb-3">
            <div className="col-md-6">
              <strong>Booking ID:</strong> {booking.booking_id || '—'}
            </div>
            <div className="col-md-6">
              <strong>Status:</strong>{' '}
              <span className={`badge ${getStatusBadgeClass(booking.status)}`}>
                {booking.status || 'N/A'}
              </span>
            </div>
          </div>

          <table className="table table-bordered">
            <tbody>
              <tr><th>Name</th><td>{booking.name}</td></tr>
              <tr><th>Email</th><td>{booking.email}</td></tr>
              <tr><th>Phone</th><td>{booking.phone}</td></tr>
              <tr><th>Date & Time</th><td>{booking.date} at {booking.time}</td></tr>
              <tr><th>Have you used any retinol, AHA/BHA products, or taken Accutane in the last 6 months?</th><td>{booking.aha_products}</td></tr>
              <tr><th>Are you pregnant or nursing?</th><td>{booking.pregnent}</td></tr>
              <tr><th>Are you currently under the care of a physician for any skin, hair, or medical condition?</th><td>{booking.medical_condition} {booking.hair_condtion_answer}</td></tr>
              <tr><th>Do you have any allergies (including latex, dyes, products, etc.)?</th><td>{booking.allergies} {booking.allergies_answer} {booking.allergies_answer}</td></tr>
              <tr><th>Amount</th><td>${booking.amount}</td></tr>
              <tr><th>Payment ID</th><td>{booking.payment_id}</td></tr>
              <tr><th>Payment Method</th><td>{booking.payment_method}</td></tr>
              <tr><th>Cancelled By</th><td>{booking.cancelled_by || '—'}</td></tr>
              <tr><th>Reason</th><td>{booking.reason || '—'}</td></tr>
              <tr><th>Created At</th><td>{booking.created_at}</td></tr>
              <tr>
                <th>Services</th>
                <td>
                  {Array.isArray(booking.services) ? (
                    <ul className="mb-0">
                      {booking.services.map((srv, index) => (
                        <li key={index}>
                          {srv.category}({srv.name}) — ${srv.price}
                        </li>
                      ))}
                    </ul>
                  ) : (
                    <span>{booking.services}</span>
                  )}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
       <BookingConfirmation
        show={modalShow}
        onHide={() => setModalShow(false)}
        onSave={(reason) => {updateStatus(reason)}}
        handleClose = {() => setModalShow(false)}
      />

    </>
  );
};

export default BookingDetails;
